import { Link, useLocation } from 'react-router-dom';
import styles from './Header.module.css';

const NAV_ITEMS = [
  { label: 'HOME', path: '/' },
  { label: 'SERVICES', path: '/services' },
  { label: 'ABOUT', path: '/about' },
  { label: 'CONTACT', path: '/contact' },
];

/**
 * Header navigation component.
 *
 * DOS-style navigation bar.
 */
export function Header() {
  const location = useLocation();

  return (
    <header className={styles.header}>
      <nav className={styles.nav} aria-label="Main navigation">
        <ul className={styles.navList}>
          {NAV_ITEMS.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`${styles.navLink} ${location.pathname === item.path ? styles.active : ''}`}
                aria-current={location.pathname === item.path ? 'page' : undefined}
              >
                [{item.label}]
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
